var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslationLangIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9922_4308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9922_4308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23.4961V0.496096H0.5V23.4961H23.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9922_4308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.297 12.2797V21.8877C23.297 22.6639 22.6679 23.293 21.8917 23.293H12.2837C11.5075 23.293 10.8779 22.6639 10.8779 21.8877V13.1183H11.7165C12.4928 13.1183 13.1223 12.4887 13.1223 11.7125V10.8739H16.7092C17.7221 8.31406 20.1925 8.06328 20.1925 8.06328V10.8739H21.8917C22.6679 10.8739 23.297 11.5034 23.297 12.2797Z",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1222 2.10531V11.7133C13.1222 12.4895 12.4927 13.1191 11.7164 13.1191H7.29094C6.27797 15.6789 3.80766 15.9297 3.80766 15.9297V13.1191H2.10844C1.33219 13.1191 0.703125 12.4895 0.703125 11.7133V2.10531C0.703125 1.32906 1.33219 0.7 2.10844 0.7H11.7164C12.4927 0.7 13.1222 1.32906 13.1222 2.10531Z",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08984 5.21484H9.73477",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9126 5.21484V4.08586",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50146 5.21453C5.50146 9.73047 9.73517 9.73047 9.73517 9.73047",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32355 5.21453C8.32355 9.73047 4.08984 9.73047 4.08984 9.73047",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2651 19.9062L17.0876 14.2613L19.9101 19.9062",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9707 18.4941H19.2044",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9321 2.11094H17.6377C20.7553 2.11094 23.2827 4.63825 23.2827 7.75586",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6378 3.52148L16.2266 2.11027L17.6378 0.699",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05366 21.8672H6.34805C3.23044 21.8672 0.703125 19.3399 0.703125 16.2223",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34814 20.4568L7.75936 21.868L6.34814 23.2793",
    stroke: "#1D2939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9922_4308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationLangIcon);
export default __webpack_public_path__ + "static/media/translation-lang-icon.f557ca39.svg";
export { ForwardRef as ReactComponent };